var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-toast__container"},[_c('div',[_c('span',{class:{
        'chat-message__author': true,
        'primary--text': _vm.message.user.isVIP
      }},[_vm._v(" "+_vm._s(_vm.lowerName)+" ")])]),_c(_vm.messageComponent,{tag:"component",attrs:{"message":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }